import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import styled from 'styled-components';
import {MotifImageIcFilterNone24px} from '@ey-xd/motif-icon';
import {useAresUrlTrackChangesParameters} from '../../../../src/util/Ares/customHooks';
import {labels} from '../../../../src/util/utils';
import Utility from '../../../../src/util/utilityfunctions';
import {useDocumentId, useEngagementId, useUserPreferences} from '../../../util/customHooks';
import {useIsTrackChangesView} from '../../../../src/util/Ares/customHooks';
import {getSnapshotsForDocument} from '../../../../src/actions/Snapshot/snapshotsactions';
import {loadStorage, clearItem} from '../localStorage';
import EllipseControl from '../../../../src/components/Common/EllipsesControl/EllipsesControl';
import EllipsesMoment from '../../../../src/components/Common/EllipsesControl/EllipseMoment';
import Icon from '../../Common/BaseComponentWrappers/MotifIcon';
import Ellipses from '../../Common/EllipsesControl/EllipsesPresets';

function TrackChangesHeaderDisplay({
	headerId,
	sectionId,
	documentTypeId,
	taskId,
	isSummary,
	activityName,
	isDuplicate
}) {
	const dispatch = useDispatch();

	const snapshots = useSelector((store) => store.snapshots),
		userPreferences = useUserPreferences(),
		engagementId = useEngagementId(),
		documentId = useDocumentId();

	const isTrackChangesView = useIsTrackChangesView();
	const taskIdCurrentView = loadStorage('taskIdCurrentView');
	const {snapshotId} = useAresUrlTrackChangesParameters();

	const documentSnapshots = snapshots?.filter((s) => s.documentId === documentId);

	const formatedSnapshotList = Utility.formatSnapshotsName(documentSnapshots);
	const currentSnapshot = formatedSnapshotList.find(
		(x) => x.value === (snapshotId ?? loadStorage('selectedTrackChangesSnapshotId'))
	);
	const isRedirectedFromSummaryPage = loadStorage('isRedirectedFromSummaryPage');

	const navigateToNonTrackChangeView = () => {
		const queryString = {
			isDrawer: false
		};

		const url = Utility.getAresTaskListNavigationUrl(
			documentId,
			headerId,
			sectionId,
			engagementId,
			taskId,
			queryString,
			documentTypeId,
			false,
			false
		).split('?'[1]);

		navigate(url[0]);
	};

	useEffect(() => {
		if (!currentSnapshot && engagementId && documentId) {
			dispatch(getSnapshotsForDocument(engagementId, documentId));
		}
	}, [snapshotId]);

	useEffect(() => {
		if (!isTrackChangesView) {
			clearItem('selectedTrackChangesSnapshotId');
		} else if (taskIdCurrentView && taskIdCurrentView !== taskId) {
			clearItem('selectedTrackChangesSnapshotId');
			clearItem('taskIdCurrentView');
			navigateToNonTrackChangeView();
		}

		// This is done to clear the storage when component unmounts
		return () => {
			clearItem('selectedTrackChangesSnapshotId');
		};
	}, []);

	const getSnapshotName = ({label, userName, createDate}) => {
		return (
			<>
				<section className="snapshotVersionSelectedText">
					{labels.trackChangesVersionLabel}
					{': '}
				</section>
				<section className="selectText">
					{userName ? (
						<>
							<section className="snapshotOptionNameLabelWrapper">
								<EllipseControl
									id="snapshotOptionNameLabel"
									content={userName}
									tooltip={userName}
									displayId={''}
									noOfLines={1}
								/>
							</section>
							<span className="snapshotOptionHyphenWrapper">{'-'}</span>
							<section className="snapshotOptionDateLabelWrapper">
								<EllipsesMoment
									id="snapshotOptionDateLabel"
									useFormat
									userPreferences={userPreferences}
									date={createDate}
									useLocal={false}
								/>
							</section>
						</>
					) : (
						<section className="snapshotOptionLabelWrapper">
							<EllipseControl id="snapshotOptionLabel" content={label} tooltip={label} displayId={''} noOfLines={1} />
						</section>
					)}
				</section>
			</>
		);
	};

	return (
		<StyledTrackChangesHeaderDisplay className="StyledTrackChangesHeaderDisplay">
			<section className="track-changes-header-display-Wrapper">
				<section className="track-changes-title-section">
					<h1 className="track-changes-title-heading">
						<Ellipses.Single>{`${labels.trackChanges}: ${activityName}`}</Ellipses.Single>
						{isDuplicate && (
							<Icon className="duplicate-icon" src={MotifImageIcFilterNone24px} title={labels.duplicate} />
						)}
					</h1>
					<section className="track-changes-subtitle-snapshot-version">
						{(isSummary || isRedirectedFromSummaryPage) && currentSnapshot && getSnapshotName(currentSnapshot)}
					</section>
				</section>
			</section>
		</StyledTrackChangesHeaderDisplay>
	);
}

export default TrackChangesHeaderDisplay;

const StyledTrackChangesHeaderDisplay = styled.section`
	.track-changes-title-section {
		display: flex;
		width: 100%;
		flex-direction: column;
		.track-changes-title-heading {
			display: flex;
			width: auto;
			font-size: var(--px-32);
			font-weight: 400;
			line-height: var(--px-42);
			color: var(--neutrals-1000);
			margin: 0;
			.duplicate-icon {
				margin-left: var(--px-12);
			}
			.motif-icon svg {
				width: var(--px-24);
				height: var(--px-24);
			}
		}
		.track-changes-subtitle-snapshot-version {
			display: flex;
			width: auto;
			align-items: center;
			.snapshotVersionSelectedText {
				font-size: var(--px-14);
				font-weight: 400;
				line-height: var(--px-24);
				color: var(--neutrals-900);
				margin-right: var(--px-8);
			}
			.selectText {
				display: flex;
				width: auto;
				background-color: var(--neutrals-00white);
				border: var(--px-1) solid var(--neutrals-900);
				padding: var(--px-3) var(--px-8);
				border-radius: var(--px-20);
				.snapshotOptionNameLabelWrapper,
				.snapshotOptionDateLabelWrapper {
					max-width: var(--px-250);
					.ellipses {
						div {
							font-size: var(--px-12);
							font-weight: 400;
							line-height: var(--px-24);
							color: var(--neutrals-900);
						}
					}
				}
				.snapshotOptionHyphenWrapper {
					margin: var(--px-1) var(--px-5) 0;
					font-size: var(--px-20);
				}
			}
		}
	}
`;
